import React from 'react';
import Icon from '../../../components/AppIcon';

const milestones = [
  {
    phase: 'Land Registration',
    icon: 'FileText',
    status: 'completed',
    date: 'Step 1',
    description: 'Register land with Sub-Registrar office and obtain mutation (namjari) from local authority',
    docs: ['Deed of Sale', 'Mutation Certificate', 'Khatian (Land Record)']
  },
  {
    phase: 'RAJUK Approval',
    icon: 'Shield',
    status: 'completed',
    date: 'Step 2',
    description: 'Submit building plan to RAJUK for approval. Requires land use clearance and FAR compliance',
    docs: ['Building Plan Approval', 'Land Use Clearance', 'FAR Certificate']
  },
  {
    phase: 'Building Permit',
    icon: 'Building2',
    status: 'completed',
    date: 'Step 3',
    description: 'Obtain construction permit from RAJUK or CDA (Chittagong). Structural design approval required',
    docs: ['Construction Permit', 'Structural Design Approval', 'Environmental Clearance']
  },
  {
    phase: 'Construction Phase',
    icon: 'Hammer',
    status: 'active',
    date: 'Step 4',
    description: 'Active construction with periodic RAJUK inspections. Deviations from approved plan are violations',
    docs: ['Inspection Reports', 'Progress Certificates', 'Utility Connections']
  },
  {
    phase: 'Completion Certificate',
    icon: 'Award',
    status: 'pending',
    date: 'Step 5',
    description: 'RAJUK issues completion certificate after final inspection confirming plan compliance',
    docs: ['Completion Certificate', 'Fire Safety Certificate', 'Utility Approval']
  },
  {
    phase: 'Title Deed Transfer',
    icon: 'Key',
    status: 'pending',
    date: 'Step 6',
    description: 'Transfer title deed at Sub-Registrar office. Pay stamp duty and registration fees',
    docs: ['Title Deed', 'Stamp Duty Receipt', 'Registration Certificate']
  }
];

const statusStyles = {
  completed: { color: '#22c55e', bg: 'rgba(34,197,94,0.15)', border: 'rgba(34,197,94,0.4)', line: '#22c55e' },
  active: { color: '#00B450', bg: 'rgba(0,180,80,0.15)', border: 'rgba(0,180,80,0.5)', line: '#00B450' },
  pending: { color: '#6B9EC4', bg: 'rgba(107,158,196,0.08)', border: 'rgba(107,158,196,0.2)', line: 'rgba(107,158,196,0.3)' }
};

const RAJUKComplianceTimeline = () => (
  <div className="rounded-2xl p-6" style={{ background: 'rgba(10,22,40,0.9)', border: '1px solid rgba(0,180,80,0.2)' }}>
    <div className="flex items-center gap-3 mb-6">
      <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0,180,80,0.1)', border: '1px solid rgba(0,180,80,0.3)' }}>
        <Icon name="GitBranch" size={20} color="#00B450" />
      </div>
      <div>
        <h3 className="text-lg font-bold" style={{ color: '#E8F4FF' }}>RAJUK Compliance Timeline</h3>
        <p className="text-xs" style={{ color: '#6B9EC4' }}>From land registration to title deed — all regulatory milestones in Bangladesh</p>
      </div>
    </div>

    <div className="relative">
      {milestones?.map((m, i) => {
        const s = statusStyles?.[m?.status];
        return (
          <div key={i} className="flex gap-4 mb-4 last:mb-0">
            <div className="flex flex-col items-center">
              <div className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: s?.bg, border: `2px solid ${s?.border}` }}>
                <Icon name={m?.icon} size={16} color={s?.color} />
              </div>
              {i < milestones?.length - 1 && (
                <div className="w-0.5 flex-1 mt-1" style={{ background: s?.line, minHeight: 20 }} />
              )}
            </div>
            <div className="flex-1 pb-4">
              <div className="flex items-center justify-between flex-wrap gap-1 mb-1">
                <span className="font-semibold text-sm" style={{ color: '#E8F4FF' }}>{m?.phase}</span>
                <span className="text-xs px-2 py-0.5 rounded-full" style={{ background: s?.bg, color: s?.color }}>
                  {m?.status === 'completed' ? '✓ Complete' : m?.status === 'active' ? '● In Progress' : '○ Upcoming'}
                </span>
              </div>
              <p className="text-xs mb-2" style={{ color: '#6B9EC4' }}>{m?.description}</p>
              <div className="flex flex-wrap gap-1">
                {m?.docs?.map((doc, j) => (
                  <span key={j} className="text-xs px-2 py-0.5 rounded" style={{ background: 'rgba(0,180,80,0.06)', border: '1px solid rgba(0,180,80,0.15)', color: '#00B450' }}>{doc}</span>
                ))}
              </div>
              <div className="text-xs mt-1" style={{ color: '#6B9EC4' }}>📋 {m?.date}</div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default RAJUKComplianceTimeline;
